// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3PUW2","upload":"Small_upload__2DX0Q","imageWrap":"Small_imageWrap__2n3mV","removeBtn":"Small_removeBtn__3ijBY"};